import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { consumePostSignInPath, useSession } from '@/auth';

/**
 * Landing point for the OIDC redirect (`/callback`). react-oidc-context completes
 * the code exchange itself; this route only waits for the resulting session and
 * then hands back to where the user was before the redirect (stashed from
 * `url_state` by the sign-in callback), falling back to the portfolio.
 */
export const CallbackRoute = () => {
  const { t } = useTranslation();
  const session = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (session.isAuthenticated) {
      void navigate(consumePostSignInPath(window.sessionStorage) ?? '/', { replace: true });
    }
  }, [navigate, session.isAuthenticated]);

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', gap: 2, p: 8 }} data-automation-id="callback">
      <CircularProgress />
      <Typography color="text.secondary">{t('auth.CompletingSignIn')}</Typography>
    </Box>
  );
};
